<a
  class="link"
  [class.section-link]="sectionLink()"
  [class.menu-open]="mainNavService.mainNavOpen()"
  [class.menu-closed]="!mainNavService.mainNavOpen()"
  mat-list-item
  tabindex="0"
  (click)="routeTo(linkData().isDisabled ? null : linkData().link)"
  (keydown.enter)="routeTo(linkData().isDisabled ? null : linkData().link)"
  routerLinkActive="selected-route">
  <div class="link-text">
    @if (linkData().matIcon && !linkData().svgIcon) {
      <mat-icon class="icon">{{ linkData().matIcon }}</mat-icon>
    }
    @if (linkData().svgIcon) {
      <mat-icon [svgIcon]="linkData().svgIcon" class="icon white" />
    }
    <span [@animateText]="mainNavService.mainNavOpen() ? 'show' : 'hide'">
      {{ linkData().displayName }}
    </span>
    @if (!sectionLink()) {
      <mat-icon class="link-arrow">chevron_right</mat-icon>
    }
  </div>
</a>
